function responsiveMenu() {
  992 > jQuery(window).width()
    ? (jQuery("#shopify-section-TT-megamenu").insertAfter(
        ".menu_wrapper .menu_toggle_wrap .nav-toggle"
      ),
      jQuery(".sub-nav__dropdown").css("display", "none"),
      jQuery(".header_1 .menu_toggle_wrap").insertBefore(
        ".header_1 .header_logo_wrap"
      ),
      jQuery(".header_1 #shopify-section-TT-megamenu").appendTo(
        ".header_1 .menu_toggle_wrap"
      ),
      jQuery(".header_3 .left-nav").insertAfter(
        ".header_3 .tt-megamenu .tt-mega_menu .tt_menus_ul"
      ),
      jQuery(".header_3 #shopify-section-TT-megamenu").insertAfter(
        ".header_3 .menu_toggle_wrap"
      ),
      jQuery(".header_3 .header_3_wrapper .menu_toggle_wrap").insertBefore(
        ".header_3 .header_3_wrapper .header-middle .header_logo_wrap"
      ))
    : (jQuery(".header_1 .menu_toggle_wrap").insertAfter(
        ".header_1 .right-link-icon"
      ),
      jQuery(".header_3 .left-nav").insertAfter(
        ".header_3 .header-middle .header_logo_wrap"
      ),
      jQuery(".header_3 .header_3_wrapper .menu_toggle_wrap").insertBefore(
        ".header_3 .header_3_wrapper .main-header .tt-mega-menu"
      ),
      jQuery(".header_1 #shopify-section-TT-megamenu").insertAfter(
        ".header_1 .header_logo_wrap"
      ),
      jQuery(".header_3 #shopify-section-TT-megamenu").appendTo(
        ".header_3 .main-header"
      ));
}
function height() {
  var t = $(
    ".design_3 .product-single__thumbs a.product-single__thumbnail img,.design_2 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img"
  ).height();
  $(
    ".design_3 .product-single__thumbs a.product-single__thumbnail.extra-video img,.design_2 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img"
  ).height(t),
    $(
      ".design_3 .product-single__thumbs a.product-single__thumbnail.video img,.design_2 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img"
    ).height(t),
    $(
      ".design_3 .product-single__thumbs a.product-single__thumbnail.model img,.design_2 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img"
    ).height(t);
}
function productcartsticky() {
  jQuery(window).width() > 319 && jQuery(this).scrollTop() > 550
    ? jQuery(".add-to-cart-sticky").addClass("fixed")
    : jQuery(".add-to-cart-sticky").removeClass("fixed");
}
function footerToggle() {
  992 > jQuery(window).width()
    ? (jQuery(
        ".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4"
      ).addClass("toggle"),
      jQuery(
        ".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget"
      )
        .children(":nth-child(2)")
        .css("display", "none"),
      jQuery(
        ".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active"
      )
        .children(":nth-child(2)")
        .css("display", "block"),
      jQuery(
        ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
      ).unbind("click"),
      jQuery(
        ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
      ).on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast");
      }),
      jQuery(
        ".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4"
      ).addClass("toggle"),
      jQuery(
        ".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget "
      )
        .children(":nth-child(2)")
        .css("display", "none"),
      jQuery(
        ".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active"
      )
        .children(":nth-child(2)")
        .css("display", "block"),
      jQuery(
        ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
      ).unbind("click"),
      jQuery(
        ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
      ).on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast");
      }))
    : (jQuery(".sidebar-block").prependTo(".collection_sidebar"),
      jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind(
        "click"
      ),
      jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass(
        "toggle"
      ),
      jQuery(".sidebar .widget,.sidebar-block .widget")
        .children(":nth-child(2)")
        .css("display", "block"));
}
function splitStr(t, i) {
  return t.split(i);
}

function countDownIni(countdown) {
  $(countdown).each(function() {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10)
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown')
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).parent(".simple-countdown").addClass("countdown-block");
      $(this).parent().addClass('countdown-enable');
      console.log();
      countdown.countdown(promoperiod, function(event) {
        countdown.html(event.strftime('<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' + '<span><span>%H</span><span class="time-txt">hours</span></span>' + '<span><span>%M</span><span class="time-txt">min</span></span>' + '<span><span class="second">%S</span><span class="time-txt">sec</span></span>'))
      })
    }
  })
}
function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (t) {
    var i = $(this);
    i.hasClass("hb-in-viewport") ||
      setTimeout(function () {
        i.addClass("hb-in-viewport");
      }, 180 * t);
  });
}
function sidebarsticky() {
  1199 >= $(document).width()
    ? (jQuery(
        ".left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left"
      ).theiaStickySidebar({
        additionalMarginBottom: 30,
        additionalMarginTop: 30,
      }),
      jQuery(
        ".design_2 .additinal-product,.design_2 .product-information, .design_2 .product-wrapper-owlslider"
      ).theiaStickySidebar({ additionalMarginTop: 30 }))
    : $(document).width() >= 1200 &&
      (jQuery(
        ".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left"
      ).theiaStickySidebar({
        additionalMarginBottom: 30,
        additionalMarginTop: 130,
      }),
      jQuery(
        ".design_2 .additinal-product,.design_2 .product-information, .design_2 .product-wrapper-owlslider"
      ).theiaStickySidebar({ additionalMarginTop: 50 }));
}
function bindgrid() {
  "grid" == localStorage.getItem("display")
    ? jQuery("#grid-view").trigger("click")
    : "grids" == localStorage.getItem("display")
    ? jQuery("#grid-views").trigger("click")
    : "list" == localStorage.getItem("display")
    ? jQuery("#list-view").trigger("click")
    : "short-list" == localStorage.getItem("display")
    ? jQuery("#short-list-view").trigger("click")
    : jQuery("#grid-view").trigger("click"),
    768 > jQuery(window).width() &&
      jQuery("#grid-view").hasClass("active") &&
      (jQuery("#grid-views").toggleClass("active"),
      jQuery("#grid-views").trigger("click"),
      jQuery("#grid-view").removeClass("active")),
    481 > jQuery(window).width() &&
      jQuery("#list-view").hasClass("active") &&
      (jQuery("#short-list-view").toggleClass("active"),
      jQuery("#short-list-view").trigger("click"),
      jQuery("#list-view").removeClass("active"));
}
$(document).ready(function () {
  (function (t) {
    "use strict";
    t(document).ready(function () {
      var i = document.querySelector(".progress-wrap path"),
        a = i.getTotalLength();
      (i.style.transition = i.style.WebkitTransition = "none"),
        (i.style.strokeDasharray = a + " " + a),
        (i.style.strokeDashoffset = a),
        i.getBoundingClientRect(),
        (i.style.transition = i.style.WebkitTransition =
          "stroke-dashoffset 10ms linear");
      var s = function () {
        var s = t(window).scrollTop(),
          o = t(document).height() - t(window).height();
        i.style.strokeDashoffset = a - (s * a) / o;
      };
      s(),
        t(window).scroll(s),
        jQuery(window).on("scroll", function () {
          jQuery(this).scrollTop() > 50
            ? jQuery(".progress-wrap").addClass("active-progress")
            : jQuery(".progress-wrap").removeClass("active-progress");
        }),
        jQuery(".progress-wrap").on("click", function (t) {
          return (
            t.preventDefault(),
            jQuery("html, body").animate({ scrollTop: 0 }, 550),
            !1
          );
        });
    });
  })(jQuery),
    jQuery(".nav-toggle").click(function (t) {
      jQuery(this).toggleClass("active"),
        t.stopPropagation(),
        jQuery(" #tt-megamenu .tt-mega_menu").addClass("active"),
        jQuery("body").toggleClass("menu_hover");
    }),
    jQuery("#shopify-section-TT-megamenu .menu-close").on(
      "click",
      function (t) {
        jQuery(" #tt-megamenu .tt-mega_menu").removeClass("active"),
          jQuery("body").removeClass("menu_hover");
      }
    ),
    jQuery(
      ".header_1 #tt-megamenu .tt-mega_menu,.header_3 #tt-megamenu .tt-mega_menu"
    ).hover(
      function () {
        jQuery("body").addClass("menu_hover");
      },
      function () {
        jQuery("body").removeClass("menu_hover");
      }
    ),
    $(".header-close").on("click", function () {
      $(".header-top").slideToggle("slow", function () {}),
        jQuery("body").addClass("header-close");
    }),
    jQuery(".filter-toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".filter-toggle-wrap").slideToggle("is-visible");
    });
  var t = jQuery(this).find(".full_width .sorting_wrapper");
  jQuery(this).find(".filter-toggle").insertBefore(t),
    jQuery(".product-single__thumbs img").on("click", function () {
      var t = jQuery(this).attr("src");
      "" != t &&
        jQuery(this)
          .closest(".product-wrapper")
          .find("img.grid-view-item__image")
          .first()
          .attr("src", t),
        jQuery(this)
          .parent(".grid-item")
          .addClass("open")
          .siblings(".grid-item")
          .removeClass("open");
    });
  var i = jQuery(".popup_overlay");
  function a(t) {
    var i = document
      .getElementById("popupVid")
      .getElementsByTagName("iframe")[0].contentWindow;
    (func = "hide" == t ? "pauseVideo" : "playVideo"),
      i.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
  }
  jQuery(".play-icone").click(function () {
    jQuery("body").addClass("popup-toggle"), i.css("display", "block");
  }),
    i.click(function (t) {
      (e = t || window.event).target == this &&
        (jQuery(i).css("display", "none"),
        jQuery("body").removeClass("popup-toggle"));
    }),
    jQuery(".popup_close").click(function () {
      i.css("display", "none"), jQuery("body").removeClass("popup-toggle");
    }),
    jQuery(".play-icone").click(function () {
      i.css("visibility", "visible").css("opacity", "1");
    }),
    i.click(function (t) {
      (e = t || window.event).target == this &&
        (jQuery(i).css("visibility", "hidden").css("opacity", "0"), a("hide"));
    }),
    jQuery(".popup_close").click(function () {
      i.css("visibility", "hidden").css("opacity", "0"), a("hide");
    }),
    jQuery(".shopify-payment-button .shopify-payment-button__button").prepend(
      // jQuery("<i class='mdi mdi-cart-outline'></i>")
    );
  var s = $(window).width();
  $(".slider-content-main-wrap").css("width", s),
    $(".site-header").hasClass("header_transaparent") &&
      $("body.template-index").addClass("header_transaparent"),
    jQuery(".filter-left").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".off-canvas.position-left").addClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".filter-right").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".off-canvas.position-right").addClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".off-canvas .sidebar_close").on("click", function (t) {
      t.preventDefault(),
        jQuery(".off-canvas.position-left").removeClass("is-open"),
        jQuery(".off-canvas.position-right").removeClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".is-overlay-fixed").on("click", function (t) {
      t.preventDefault(),
        jQuery(".filter-left").trigger("click"),
        jQuery(".filter-right").trigger("click"),
        jQuery(".off-canvas.position-left").removeClass("is-open"),
        jQuery(".off-canvas.position-right").removeClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
          "is-visible is-closable"
        );
    }),
    $(".product-360-button a").magnificPopup({
      type: "inline",
      mainClass: "mfp-fade",
      removalDelay: 160,
      disableOn: !1,
      preloader: !1,
      fixedContentPos: !1,
      callbacks: {
        open: function () {
          $(window).resize();
        },
      },
    }),

     countDownIni(".flip-countdown,.js-flip-countd");
    
    $(".popup-video").magnificPopup({
      disableOn: 300,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: !1,
      fixedContentPos: !1,
    }),
    ($("a.product-lightbox-btn").length > 0 ||
      $("a.product-video-popup").length > 0) &&
      $(
        ".product-single__photos .gallery,.design_2 .product-img"
      ).magnificPopup({
        delegate: "a",
        type: "image",
        tLoading:
          '<div class="please-wait dark"><span></span><span></span><span></span></div>',
        removalDelay: 300,
        closeOnContentClick: !0,
        gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
        image: {
          verticalFit: !1,
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        },
        callbacks: {
          beforeOpen: function () {
            var t = $(".product-video-popup").attr("href");
            if (t) {
              this.st.mainClass = "has-product-video";
              var i = $.magnificPopup.instance;
              i.items.push({ src: t, type: "iframe" }), i.updateItemHTML();
            }
          },
          open: function () {},
        },
      }),
    $(".design_3 .product-img,.design_5 .pro_img").magnificPopup({
      delegate: "a",
      type: "image",
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: !0,
      gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
      image: {
        verticalFit: !1,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var t = $(".product-video-popup").attr("href");
          if (t) {
            this.st.mainClass = "has-product-video";
            var i = $.magnificPopup.instance;
            i.items.push({ src: t, type: "iframe" }), i.updateItemHTML();
          }
        },
        open: function () {},
      },
    }),
    $(".qtyplus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var i = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      jQuery(".cart-update .quantity").data("item-id"),
        isNaN(i)
          ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
          : jQuery(this)
              .parents(".qty-box-set")
              .find(".quantity")
              .val(i + 1);
    }),
    $(".qtyminus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var i = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      !isNaN(i) && i > 1
        ? jQuery(this)
            .parents(".qty-box-set")
            .find(".quantity")
            .val(i - 1)
        : jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
    }),
    jQuery(document).on("click", function (t) {
      var i = jQuery(".myaccount")[0],
        a = jQuery(".myaccount");
      a === t.target ||
        a.has(t.target).length ||
        i === t.target ||
        (jQuery(".customer_account").slideUp("fast"),
        jQuery("body").removeClass("account-toggle"),
        jQuery(".myaccount").removeClass("open"));
      var s = jQuery("body .site-header__search")[0],
        o = jQuery("body .site-header__search");
      o === t.target ||
        o.has(t.target).length ||
        s === t.target ||
        (jQuery("body .search-full-screen").slideUp("slow"),
        jQuery("body").removeClass("search_full_active"),
        jQuery("body").removeClass("search_toggle"),
        jQuery("body .search_toggle").removeClass("active"));
    }),
    jQuery(".overlay").click(function () {
      jQuery("#slidedown-cart,.site-header_cart_link").removeClass("active"),
        jQuery(".fixed-cart-wrap").removeClass("active"),
        jQuery("body").removeClass("cart_toggle");
    }),
    $("#navToggle").on("click", function (t) {
      jQuery(this).next(".Site-navigation").slideToggle(500);
    }),
    $(".menu_toggle_wrap #navToggle").on("click", function (t) {
      jQuery(this).parent().next(".Site-navigation").slideToggle(500);
    }),
    jQuery("body.footer_style_1 .footer_toggle").on("click", function (t) {
      jQuery("#shopify-section-footer-model-1").addClass("toggle-footer"),
        jQuery("body").addClass("footer1-open"),
        t.preventDefault();
    }),
    jQuery("body.footer_style_1 .footer_close_toggle").on(
      "click",
      function (t) {
        jQuery("#shopify-section-footer-model-1").removeClass("toggle-footer"),
          jQuery("body").removeClass("footer1-open"),
          t.preventDefault();
      }
    ),
    $(
      ".header_1 .fullscreen_header_toggle,.header_3 .fullscreen_header_toggle"
    ).on("click", function (t) {
      t.preventDefault(),
        $(this).toggleClass("active"),
        $(".tt-megamenu1").slideToggle(),
        $("body").toggleClass("fullnav-open");
    }),
    $(
      ".header_1 .right-icon .tt-mega_menu1 .menu-close,.header_3 .tt-mega_menu1 .menu-close"
    ).on("click", function (t) {
      $(".tt-megamenu1").slideUp(), $("body").removeClass("fullnav-open");
    }),
    jQuery(".site-header__search.search-full .serach_icon").on(
      "click",
      function (t) {
        t.preventDefault(),
          jQuery(this).toggleClass("active"),
          jQuery("body").toggleClass("search_full_active"),
          jQuery(".search-full-screen").slideToggle("slow"),
          jQuery(".full-search-wrapper").addClass("search-overlap"),
          jQuery(".myaccount  .dropdown-toggle").removeClass("open"),
          jQuery(".myaccount  .customer_account").slideUp("fast"),
          jQuery(".site-header .site-header_cart_link").removeClass("active"),
          jQuery(".fixed-cart-wrap").removeClass("active"),
          jQuery(".search-bar > input").focus(),
          jQuery("body").toggleClass("search_toggle"),
          jQuery("body").removeClass("account-toggle"),
          jQuery("body").removeClass("cart_toggle");
      }
    ),
    jQuery(".site-header__search.search-full .close-search").on(
      "click",
      function () {
        jQuery(".site-header__search.search-full .serach_icon").removeClass(
          "active"
        ),
          jQuery(".full-search-wrapper").removeClass("search-overlap"),
          jQuery("body").removeClass("search_full_active"),
          jQuery("body").removeClass("search_toggle"),
          jQuery(".search-full-screen").slideUp("slow");
      }
    ),
    jQuery(".myaccount  span.dropdown-toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery(".customer_account").slideToggle("fast"),
        jQuery(this).toggleClass("open"),
        jQuery("body").toggleClass("account-toggle"),
        jQuery(".search_wrapper").slideUp("fast"),
        jQuery(
          ".site-header__search:not(.search-full) .serach_icon"
        ).removeClass("active"),
        jQuery("body").removeClass("search_full_active"),
        jQuery("body").removeClass("currency-open"),
        jQuery("body").removeClass("language-open"),
        jQuery(".site-header .site-header_cart_link").removeClass("active"),
        jQuery(".fixed-cart-wrap").removeClass("active"),
        jQuery("body").removeClass("search_toggle"),
        jQuery("body").removeClass("cart_toggle");
    }),
    jQuery(".header_language .disclosure__toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery("body").toggleClass("language-open"),
        jQuery("body").removeClass("currency-open"),
        jQuery("body").removeClass("myaccount_active"),
        jQuery("body").removeClass("cart_toggle"),
        jQuery(".currency_wrapper").removeClass("active"),
        jQuery(".disclosure-list").slideToggle("fast"),
        jQuery(this).toggleClass("active"),
        jQuery(".customer_account").slideUp("fast"),
        jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
        jQuery(".fixed-cart-wrap").removeClass("active");
    }),
    $(".header_currency .currency_wrapper.dropdown-toggle").on(
      "click",
      function (t) {
        t.preventDefault(),
          jQuery("body").toggleClass("currency-open"),
          jQuery("body").removeClass("language-open"),
          jQuery("body").removeClass("myaccount_active"),
          jQuery("body").removeClass("cart_toggle"),
          jQuery(".disclosure__toggle").removeClass("active"),
          jQuery(".currencies.flag-dropdown-menu").slideToggle("fast"),
          $(this).toggleClass("active"),
          jQuery(".customer_account").slideUp("fast"),
          jQuery(".header_language .disclosure-list").slideUp("fast"),
          jQuery(".fixed-cart-wrap").removeClass("active");
      }
    );
  var o = jQuery(".slider-specialproduct").data("col");
  new Swiper(".special-product-div .special-product", {
    slidesPerView: o,
    loop: !1,
    breakpoints: {
      100: { slidesPerView: 1 },
      420: { slidesPerView: 2 },
      650: { slidesPerView: 3 },
      1200: { slidesPerView: o },
    },
  }),
    new Swiper("#tt-megamenu .list_products_menu", {
      slidesPerView: 5,
      loop: !1,
      breakpoints: {
        100: { slidesPerView: 1 },
        360: { slidesPerView: 2 },
        768: { slidesPerView: 4 },
        1200: { slidesPerView: 5 },
      },
    }),
    new Swiper(".top-products ", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next.best-seller",
        prevEl: ".swiper-button-prev.best-seller",
      },
      breakpoints: { 100: { slidesPerView: 1 }, 1200: { slidesPerView: 1 } },
    }),
    jQuery(".spr-summary-actions-newreview").on("click", function (t) {
      t.preventDefault(), jQuery(".spr-content").slideToggle("slow");
    }),
    $(
      ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js"
    ).click(function () {
      $(this).addClass("loading"),
        setTimeout(function () {
          $(
            ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js"
          ).removeClass("loading");
        }, 2e3);
    });
  var l = window.pageYOffset;
  (window.onscroll = function (t) {
    var i = window.pageYOffset;
    l > i
      ? (document.getElementById("header-sticky").style.top = "0")
      : $("body").hasClass("account-toggle") ||
        $("body").hasClass("menu_hover") ||
        $("body").hasClass("cart_toggle") ||
        $("body").hasClass("search_toggle")
      ? ((document.getElementById("header-sticky").style.top = "0"),
        t.stopPropagation())
      : (document.getElementById("header-sticky").style.top = "-100px"),
      (l = i);
  }),
    jQuery(".product-thumb .grid-view-item__links").each(function () {
      // jQuery(this).hoverdir();
    });
}),
  jQuery(document).ready(function () {
    responsiveMenu(),
      jQuery(".product-write-review").on("click", function (t) {
        t.preventDefault(),
          $("a[href='#tab-2']").trigger("click"),
          jQuery("html, body").animate(
            { scrollTop: jQuery(".product_tab_wrapper").offset().top - 150 },
            1e3
          );
      });
  }),
  jQuery(window).scroll(function () {
    jQuery(document).height() > jQuery(window).height() &&
      (jQuery(window).scrollTop() > 100
        ? jQuery("#GotoTop").fadeIn()
        : jQuery("#GotoTop").fadeOut());
  }),
  jQuery(document).ready(function () {
      jQuery(".product-write-review").on("click", function (t) {
        t.preventDefault(),
          $("a[href='#tab-2']").trigger("click"),
          jQuery("html, body").animate(
            { scrollTop: jQuery(".product_tab_wrapper").offset().top - 150 },
            1e3
          );
      });
  }),
  jQuery(window).resize(function () {
    responsiveMenu();
    var t = $(window).width();
    $(".slider-content-main-wrap").css("width", t);
  }),
  $(document).ready(function () {
    height();
  }),
  $(window).resize(function () {
    height();
  }),
  $(window).scroll(function () {
    height();
  }),
  $(document).ready(function () {
    productcartsticky();
  }),
  jQuery(window).resize(function () {
    productcartsticky();
  }),
  jQuery(window).scroll(function () {
    productcartsticky();
  }),
  jQuery(document).ready(function () {
    footerToggle();
  }),
  jQuery(window).resize(function () {
    footerToggle();
  }),
  $(window).scroll(function () {
    hb_animated_contents();
  }),
  $(window).load(function () {
    hb_animated_contents();
  }),
  jQuery(document).ready(function () {
    sidebarsticky();
  }),
  jQuery(window).resize(function () {
    sidebarsticky();
  }),
  jQuery(function () {
    var t = function (t, i) {
      (this.el = t || {}),
        (this.multiple = i || !1),
        $("ul.tt_menus_ul1 > li.tt_mm_hassub").addClass("active"),
        this.el
          .find("li.tt_mm_hassub .mobile-nav__sublist-trigger")
          .on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    (t.prototype.dropdown = function (t) {
      t.preventDefault();
      var i = t.data.el;
      ($next = ($this = $(this)).next()).slideToggle(),
        $this.parent().toggleClass("open"),
        t.data.multiple ||
          i
            .find("li.tt_mm_hassub .tt_sub_menu_wrap")
            .not($next)
            .slideUp()
            .parent()
            .removeClass("open");
    }),
      new t($(".tt_menus_ul1"), !1);
  }),
  jQuery(function () {
    if (!$("body").hasClass("fullnav-open")) {
      var t = function (t, i) {
        (this.el = t || {}),
          (this.multiple = i || !1),
          this.el
            .find("li.tt_mm_hassub .mobile-nav__sublist-trigger")
            .on(
              "click",
              { el: this.el, multiple: this.multiple },
              this.dropdown
            );
      };
      (t.prototype.dropdown = function (t) {
        var i = t.data.el;
        ($next = ($this = $(this)).next()).slideToggle(),
          $this.parent().toggleClass("open"),
          t.data.multiple ||
            i
              .find("li.tt_mm_hassub .tt_sub_menu_wrap")
              .not($next)
              .slideUp()
              .parent()
              .removeClass("open");
      }),
        new t($(".tt_menus_ul"), !1);
    }
  }),
  jQuery(function () {
    var t = function (t, i) {
      (this.el = t || {}),
        (this.multiple = i || !1),
        this.el
          .find(".toggle")
          .on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    (t.prototype.dropdown = function (t) {
      var i = t.data.el;
      ($next = ($this = $(this)).next()).slideToggle(),
        $this.parent().toggleClass("active"),
        t.data.multiple ||
          i
            .find(".inline-list")
            .not($next)
            .slideUp()
            .parent()
            .removeClass("active");
    }),
      new t($(".footer-column"), !1);
  }),
  $(document).ready(function () {
    bindgrid();
  }),
  $(window).load(function () {
    bindgrid();
  }),
  $(window).resize(function () {
    bindgrid();
  });
